

<div class="row">
    <!--<div class="col-xl-12 col-md-12">

        <button  type="button" class="btn btn-warning " (click)="voltar()">
            <i  class="feather icon-arrow-left mr-2 f-18"></i> Voltar </button>
        <br> <br> 
    </div>-->
   
    <!-- product profit start -->
    <div class="col-xl-3 col-md-6">
      <app-card [hidHeader]="true" cardClass="prod-p-card bg-info">
        <div class="row align-items-center ">
          <div class="col">
            <h6 class=" text-white">Total Doc. a subir</h6>
            <h3 class=" text-white">2</h3>
          </div>
          <!--<div class="col-auto">
            <i class="fas fa-money-bill-alt text-white"></i>
          </div>-->
        </div>
      </app-card>
    </div>
    <div class="col-xl-3 col-md-6">
      <app-card [hidHeader]="true" cardClass="prod-p-card bg-c-blue">
        <div class="row align-items-center ">
          <div class="col">
            <h6 class="m-b-5 text-white">Total Doc. válidos</h6>
            <h3 class=" text-white">4</h3>
          </div>
         
        </div>
      </app-card>
    </div>
    <div class="col-xl-3 col-md-6">
      <app-card [hidHeader]="true" cardClass="prod-p-card bg-c-red">
        <div class="row align-items-center ">
          <div class="col">
            <h6 class="m-b-5 text-white">Total Doc Vencidos</h6>
            <h3 class=" text-white">1</h3>
          </div>
        
        </div>
      </app-card>
    </div>
    <div class="col-xl-3 col-md-6">
      <app-card [hidHeader]="true" cardClass="prod-p-card bg-c-yellow">
        <div class="row align-items-center ">
          <div class="col">
            <h6 class="m-b-5 text-white">Total Doc a vencer</h6>
            <h3 class=" text-white">1</h3>
          </div>
         
        </div>
      </app-card>
    </div>
    <!-- product profit end -->
  
    <!-- account-section start -->
  
    <div class="col-xl-6">
      <app-card cardTitle="Validade documentos" cardClass="feed-card" blockClass="scrollable-body">
        <perfect-scrollbar [style.max-height]="'385px'">
          
          <div class="row m-b-25 align-items-center">
            <div class="col-auto p-r-0">
              <i class="feather icon-upload badge-light-danger feed-icon"></i>
            </div>
            <div class="col">
              <a >
                <h6 class="m-b-5">Licença Sanitária <span class="text-muted float-right f-14">Vencido</span></h6>
              </a>
            </div>
          </div>
          <div class="row m-b-25 m-t-5 align-items-center">
            <div class="col-auto p-r-0">
              <i class="feather icon-upload badge-light-primary feed-icon"></i>
            </div>
            <div class="col">
              <a >
                <h6 class="m-b-5">Alvará de Funcionamento <span class="text-muted float-right f-14">25/02/2025</span></h6>
              </a>
            </div>
          </div>
          <div class="row m-b-25 m-t-5 align-items-center">
            <div class="col-auto p-r-0">
              <i class="feather icon-upload badge-light-primary feed-icon"></i>
            </div>
            <div class="col">
              <a >
                <h6 class="m-b-5">Licença xxxx <span class="text-muted float-right f-14">05/10/2028</span></h6>
              </a>
            </div>
          </div>
          <div class="row m-b-25 m-t-5 align-items-center">
            <div class="col-auto p-r-0">
              <i class="feather icon-upload badge-light-primary feed-icon"></i>
            </div>
            <div class="col">
              <a >
                <h6 class="m-b-5">Registro Técnico <span class="text-muted float-right f-14">10/10/2027</span></h6>
              </a>
            </div>
          </div>

        </perfect-scrollbar>
      </app-card>
    </div>
    <div class="col-xl-6">
        <app-card cardTitle="Documentos Faltantes" cardClass="feed-card" blockClass="scrollable-body">
          <perfect-scrollbar [style.max-height]="'385px'">
            
            <div class="row m-b-25 align-items-center">
              <div class="col-auto p-r-0">
                <i class="feather icon-upload badge-danger feed-icon"></i>
              </div>
              <div class="col">
                <a href="javascript:">
                  <h6 class="m-b-5">Licença Ambiental <span class="text-muted float-right f-14">Subir agora</span></h6>
                </a>
              </div>
            </div>
            <div class="row m-b-25 m-t-5 align-items-center">
              <div class="col-auto p-r-0">
                <i class="feather icon-upload badge-danger feed-icon"></i>
              </div>
              <div class="col">
                <a href="javascript:">
                  <h6 class="m-b-5">Registro Técnico 2 <span class="text-muted float-right f-14">Subir agora</span></h6>
                </a>
              </div>
            </div>
  
          </perfect-scrollbar>
        </app-card>
      </div>
    <!-- account-section end -->
  

  </div>
  